import { useMutation } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { AccountApiSuccessResponse } from 'builder/modules/user'

export const useRestartSubscription = () => {
  return useMutation({
    mutationFn: async (): Promise<{ data: AccountApiSuccessResponse }> => {
      return baseClient.post('/api/builder/subscription/restart_subscription')
    },
  })
}
